import { MONTHS_LONG } from "./format";

const pad = (n) => String(n).padStart(2, "0");
const lastDay = (y, m) => new Date(Date.UTC(y, m, 0)).getUTCDate();
const shift = (y, m, n) => {
  const idx = y * 12 + (m - 1) + n;
  return [Math.floor(idx / 12), (idx % 12) + 1];
};

export const monthRange = (y, m) => ({ start: `${y}-${pad(m)}-01`, end: `${y}-${pad(m)}-${pad(lastDay(y, m))}` });

export function monthOptions(today, count = 36) {
  const [ty, tm] = today.split("-").map(Number);
  return Array.from({ length: count }, (_, i) => {
    const [y, m] = shift(ty, tm, -i);
    return { value: `${y}-${pad(m)}`, label: `${MONTHS_LONG[m - 1]} ${y}`, ...monthRange(y, m) };
  });
}

export function quarterOptions(today, count = 12) {
  const [ty, tm] = today.split("-").map(Number);
  let q = Math.ceil(tm / 3);
  let y = ty;
  return Array.from({ length: count }, () => {
    const sm = (q - 1) * 3 + 1;
    const opt = {
      value: `${y}-Q${q}`,
      label: `Q${q} ${y} (${MONTHS_LONG[sm - 1].slice(0, 3)}–${MONTHS_LONG[sm + 1].slice(0, 3)})`,
      start: `${y}-${pad(sm)}-01`,
      end: `${y}-${pad(sm + 2)}-${pad(lastDay(y, sm + 2))}`,
    };
    q -= 1;
    if (q === 0) { q = 4; y -= 1; }
    return opt;
  });
}

export function yearOptions(today, count = 10) {
  const ty = Number(today.slice(0, 4));
  return Array.from({ length: count }, (_, i) => {
    const y = ty - i;
    return { value: String(y), label: String(y), start: `${y}-01-01`, end: `${y}-12-31` };
  });
}
